import { adminHttpClient } from '../../commons/adminHttpClient'

export type MakeExpenseIneligibleRequest = {
  id: string
}

const makeIneligibleExpenseApi = (request: MakeExpenseIneligibleRequest): Promise<any> => {
  return adminHttpClient.post('/Expenses/MakeExpenseIneligible', request)
}

export default makeIneligibleExpenseApi